var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    d: "M13.2,0c1.3,0,2.4,1.1,2.4,2.4v11.2c0,1.3-1.1,2.4-2.4,2.4H2.8c-1.3,0-2.4-1.1-2.4-2.4v-2.8 h1.3v2.8c0,0.6,0.5,1.1,1.1,1.1h10.5c0.6,0,1.1-0.5,1.1-1.1V2.4c0-0.6-0.5-1.1-1.1-1.1H2.8c-0.6,0-1.1,0.5-1.1,1.1v3.2H0.4V2.4 C0.4,1.1,1.4,0,2.8,0H13.2z M6.3,3.6L10.5,8l-4.2,4.4l-0.6-0.7l2.7-2.8l-8.1,0V7.6l8.5,0L5.7,4.3L6.3,3.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.64551115357c71a5288c483ed1ab0a23.svg";
export { ForwardRef as ReactComponent };